import { trace } from 'owa-trace';
import { parse as parseUrl } from 'url';
import {
    ReplyWithAttachmentSuggestion,
    ReplyWithEndpointType,
} from '../store/schema/AttachmentSuggestions';
import MRUAttachment from '../store/schema/MRUAttachment';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { logUsage } from 'owa-analytics';

export default function convertMRUAttachmentToReplyWithAttachmentSuggestion(
    mruAttachment: MRUAttachment,
    traceId: string
): ReplyWithAttachmentSuggestion {
    try {
        const isClassic: boolean = mruAttachment.ContentSource === 'Exchange';
        let attachmentIdForClassic: string = null;

        if (isClassic) {
            attachmentIdForClassic = mruAttachment.Source.LastShared?.AttachmentId;
            if (!attachmentIdForClassic) {
                // There is no AttachmentId in LastShared object
                // Try to parse it from Url instead
                // It is the legacy OWA attachment deeplink like
                // /owa/?viewmodel=xxx&AttachmentId=yyy&ItemId=zzz&AttachmentName=aaa
                const url = parseUrl(mruAttachment.Source.Url, true);
                attachmentIdForClassic = convertRestIdToEwsId(url?.query?.AttachmentId);
            }

            if (!attachmentIdForClassic) {
                // There must be an attachment ID for classic suggestion to work
                // without it this entry is invalid
                return null;
            }
        }

        return {
            DateAccessed:
                mruAttachment.Source.LastAccessDateTime ||
                mruAttachment.Source.UserRelationship?.LastAccessDateTime,
            DateModified: mruAttachment.Source.LastModifiedDateTime,
            Endpoint:
                mruAttachment.SubstrateSearchExtendedProperties?.RelevanceRelationship ===
                'Implicit'
                    ? isClassic
                        ? ReplyWithEndpointType.MRUClassicContextual
                        : ReplyWithEndpointType.MRUContextual
                    : isClassic
                    ? ReplyWithEndpointType.MRUClassic
                    : ReplyWithEndpointType.MRUCloudy,
            FileExtension: mruAttachment.Source.FileExtension,
            FileName: mruAttachment.Source.FileName,
            FileSize: mruAttachment.Source.FileSize,
            FileSourceType: mruAttachment.ContentSource || mruAttachment.Provenance, // provenance is deprecated, see VSO 40637
            Id: isClassic ? attachmentIdForClassic : mruAttachment.Id,
            ReferenceId: mruAttachment.ReferenceId,
            SourceTitle:
                mruAttachment.Source.SiteTitle || mruAttachment.Source.LastShared.SharingSubject,
            Url: mruAttachment.Source.Url,
            TraceId: traceId,
        };
    } catch (e) {
        trace.info(
            `[convertMRUAttachmentToReplyWithAttachmentSuggestion] Error accessing MRUAttachment properties: ${e.message}`
        );
        logUsage(
            'convertMRUAttachmentToReplyWithAttachmentSuggestionError',
            { id: mruAttachment?.Id, traceId, error: e.message },
            {
                isCore: true,
            }
        );
        return null;
    }
}
